import { render, staticRenderFns } from "./ChoiceFieldInput.vue?vue&type=template&id=1f96837c&"
import script from "./ChoiceFieldInput.vue?vue&type=script&lang=js&"
export * from "./ChoiceFieldInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChoiceFieldInput.vue"
export default component.exports